import { scrollTop, scrollFunctions } from '../utils/scroll';
import { currentWindowHeight, currentBreakpointIndex, onWindowResize } from '../utils/window-resize';

let enableScrolling = false;
let scrollingSetup = false;
const testimonialsScrollers = [];
let scrollFunction;

function setupTestimonialsScrolling() {
    scrollingSetup = true;
    const testimonialsContainers = document.querySelectorAll('[data-testimonials]');

    testimonialsContainers.forEach(container => {
        const chunkSize = parseInt(container.getAttribute('data-chunk-size'));
        const itemSelector = container.getAttribute('data-item-selector');
        const containerTop = parseInt(container.getBoundingClientRect().top) + parseInt(scrollTop);
        const containerBottom = containerTop + parseInt(container.scrollHeight) + parseInt(currentWindowHeight / 2);
        const startTransform = parseInt(container.getAttribute('data-transform'));
        const movePrPx = startTransform / (containerBottom - containerTop);
        const testimonialItems = container.querySelectorAll(itemSelector);
        const chunkedItems = Array.from({length: Math.ceil(testimonialItems.length / chunkSize) }, (v, i) =>
            Array.from(testimonialItems).slice(i * chunkSize, i * chunkSize + chunkSize)
        );
        const transformArrays = chunkedItems.map(row => [row[0], row[2], row[4]]);
        const testimonialScroller = {
            container,
            containerTop,
            containerBottom,
            startTransform,
            movePrPx,
            items: []
        };

        transformArrays.forEach(transformArray => {
            transformArray.forEach(transformItem => {
                if (transformItem) {
                    testimonialScroller.items.push(transformItem);
                    transformItem.style.transform = `translateY(${startTransform}px)`;
                }
            });
        });

        testimonialsScrollers.push(testimonialScroller);
    });

    scrollFunction = function() {
        if (enableScrolling) {
            Array.from(testimonialsScrollers).forEach(scroller => {
                if (scroller.container.classList.contains('in-view')) {
                    const currentPosition = parseInt(scrollTop) + parseInt(currentWindowHeight);
                    const diff = currentPosition - scroller.containerTop;
                    const transform = scroller.startTransform - (diff * scroller.movePrPx);

                    scroller.items.forEach(item => {
                        if (item) {
                            item.style.transform = `translateY(${transform}px)`;
                        }
                    });
                }
            });
        }
    };

    // RP: We cant do this, as we want to be able to remove the scrollFunction from the scrollFunctions (in scroll.js) when we're under a certain screen size.
    // So we made srollFunctions exportable and push directly to the array, so we can remove it again when needed.
    /*onScroll(() => {
        scrollFunction();
    });*/
    scrollFunctions.push(scrollFunction);

    const config = {
        root: null,
        rootMargin: '0px',
        threshold: [0, 1]
    };

    const observer = new IntersectionObserver(onChange, config);

    function onChange(changes) {
        changes.forEach(change => {
            if (change.intersectionRatio > 0) {
                change.target.classList.add('in-view');
            } else {
                change.target.classList.remove('in-view');
            }
        });
    }

    Array.from(testimonialsScrollers).forEach(testimonialScroller => {
        observer.observe(testimonialScroller.container);
    });
}

function removeTestimonialsScrolling() {
    testimonialsScrollers.forEach(scroller => {
        scroller.items.forEach(item => {
            if (item) {
                item.style.transform = null;
            }
        });
    });

    const functionIndex = scrollFunctions.indexOf(scrollFunction);

    if (functionIndex > -1) {
        scrollFunctions.splice(functionIndex);
    }
}

export function setupTestimonials() {
    const checkVueApps = setInterval(function() {
        if (
            window.animalsOverviewLoaded === undefined|| window.animalsOverviewLoaded == true &&
            window.galleryLoaded === undefined || window.galleryLoaded == true &&
            window.openingHoursLoaded === undefined || window.openingHoursLoaded == true
        ) {
            onWindowResize(() => {
                enableScrolling = currentBreakpointIndex > 1;

                if (enableScrolling) {
                    if (!scrollingSetup) {
                        setupTestimonialsScrolling();
                    }
                } else {
                    if (scrollingSetup) {
                        removeTestimonialsScrolling();
                    }
                }
            });

            enableScrolling = currentBreakpointIndex > 1;

            if (enableScrolling) {
                setupTestimonialsScrolling();
            }
        }

        clearInterval(checkVueApps);
    },10);
}
